// import $ from 'jquery';
import { gsap } from 'gsap';
import Cookies from 'js-cookie';

export default class alertBar{

    constructor(options) {

        this.defaults = {
        	main 			: undefined,
        	$el   			: $( '.alert-bar' ),
        	debug 			: false,
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace 		= 'alert-bar';
		this.main			= this.options.main;
		this.$el 			= this.options.$el;
		this.$window        = $( window );

		this.init();

    }

    init( delay ){
    	if ( delay ){
    		setTimeout(()=>this.activate(), delay );
    	}
    	else{
    		this.activate();
    	}
    }

    activate(){


		const cookie = 'CFA-alert-bar'; // + window.location.host;
		if ( !Cookies ) {
			return;
		}


		// Check cookie 
		if ( Cookies.get( cookie ) !== "active" ) {
			// show bar
			this.$el.addClass( 'active' );
			//Assign cookie on click
			this.$el.find('.close-alert-bar').on('click', (e) => { this.close(e,cookie) } );
		}
		else{
			this.remove();
		}		
    }

    close(e, cookie){
		e.preventDefault();
		// set cookie
		Cookies.set( cookie , 'active', { expires: 90 }); // cookie will expire in 90 day

		gsap.to( this.$el, {height:0,opacity:0,duration: 0.3,onComplete:()=>{
			this.$el.remove();
			this.$window.trigger( 'resize' );
		}});
    }

    remove(){
    	this.$el.remove();
    }

}



